/* eslint-disable @typescript-eslint/no-unused-vars */
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import { getAttendenceStatus, getLeaveStatus } from 'helpers/status-badge';
import StatusBadge from 'components/custom/ui/StatusBadge';
import { Icon } from '@iconify/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIdBadge } from '@fortawesome/free-regular-svg-icons';
import { hrmsPaths } from 'constants/pagePath';
import { formatDate } from 'services/utils';

const employeeAttendanceColumn = () => [
  {
    accessorKey: 'user_attendence_date',
    accessorFn: ({ user_attendence_date }) => `${user_attendence_date}`,
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-100 rounded me-2">
            <FeatherIcon
              icon="calendar"
              size={16}
              className="text-primary-600 dark__text-primary-300"
            />
          </div>
          <span>Date</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { emp_id, date } = original;
      //   let user = user_type.toLowerCase();
      return (
        <div className="d-flex align-items-center">
          <div>
            <Link
              to={`${hrmsPaths.employee.detail(4)}`}
              className="fs-8 fw-bold"
            >
              {/* {date} */}
              {formatDate(date, 'DD MMM YYYY')}
            </Link>
          </div>
        </div>
      );
    },
    meta: {
      headerProps: {
        className: 'ps-0 border-end me-1 bg-white'
      },
      cellProps: {
        className: 'white-space-nowrap ps-0 border-end me-1 bg-white'
      }
    }
  },
  {
    accessorKey: 'punch_in',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-success-100 rounded me-2">
            <Icon
              icon="codicon:sign-in"
              fontSize={16}
              className="text-success-600 dark__text-success-300"
            />
          </div>
          <span className="">Punch In</span>
        </div>
      );
    },

    cell: ({ row: { original } }) => {
      const { punch_in } = original;
      const formattedTime = punch_in ? formatDate(punch_in, 'hh:mm A') : '--';
      return <div className="text-success fw-medium">{formattedTime}</div>;
    },

    meta: {
      headerProps: {
        className: 'ps-3 pe-3 '
      },
      cellProps: {
        className: 'white-space-nowrap fw-semi-bold ps-3 '
      }
    }
  },
  {
    accessorKey: 'lunch_break_in',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-info-100 rounded me-2">
            <Icon
              icon={'mdi:food'}
              size={16}
              className="text-info-600 dark__text-info-300"
            />
          </div>
          <span>Lunch Break</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { lunch_break_in, lunch_break_out } = original;
      return (
        <div className="d-flex align-items-center">
          <span className="fs-9 fw-medium text-800">
            {lunch_break_in || '--'}
          </span>
          {lunch_break_in && (
            <span className="fs-9 fw-medium text-800 px-1">/</span>
          )}
          <span className="fs-9 fw-medium text-800">{lunch_break_out}</span>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: '15%' },
        className: 'ps-3 pe-4 '
      },
      cellProps: {
        className: 'white-space-nowrap ps-3  '
      }
    }
  },
  {
    accessorKey: 'casual_break_in',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-info-100 rounded me-2">
            <FontAwesomeIcon
              icon={faIdBadge}
              size={16}
              className="text-info-600 dark__text-info-300"
            />
          </div>
          <span>Casual Break</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { casual_break_in, casual_break_out } = original;
      return (
        <div className="d-flex align-items-center">
          <span className="fs-9 fw-medium text-800">
            {casual_break_in || '--'}
          </span>
          {casual_break_in && (
            <span className="fs-9 fw-medium text-800 px-1">/</span>
          )}
          <span className="fs-9 fw-medium text-800">{casual_break_out}</span>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: '15%' },
        className: 'ps-3 pe-4 '
      },
      cellProps: {
        className: 'white-space-nowrap ps-3  '
      }
    }
  },
  {
    accessorKey: 'punch_out',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-danger-100 rounded me-2">
            <Icon
              icon="codicon:sign-out"
              fontSize={16}
              className="text-danger-600 dark__text-danger-300"
            />
          </div>
          <span className="">Punch Out</span>
        </div>
      );
    },

    cell: ({ row: { original } }) => {
      const { punch_out } = original;
      const formattedTime = punch_out ? formatDate(punch_out, 'hh:mm A') : '--';
      return <div className="text-success fw-medium">{formattedTime}</div>;
    },
    meta: {
      headerProps: {
        className: 'ps-3 pe-3 '
      },
      cellProps: {
        className: 'white-space-nowrap fw-semi-bold ps-3 '
      }
    }
  }
  // {
  //   accessorKey: 'status',
  //   header: 'status',
  //   cell: ({ row: { original } }) => (
  //     <StatusBadge status={original.status} getStatus={getAttendenceStatus} />
  //   )
  // }
];

export default employeeAttendanceColumn;
